'use client';

import dynamic from 'next/dynamic';
import { useFonPleerVklyuchen } from '@/components/aisearch/fon-pleer-vklyuchenie';

/**
 * Ядро плеера грузится отдельным куском и только после включения: этот
 * компонент стоит в общем layout всех доменов, и без отложенной загрузки
 * код плеера уезжал бы на каждую страницу ingdg.com и datahunter.store.
 * На витрине aisearch кусок к этому моменту почти целиком уже загружен:
 * те же модули нужны панели.
 */
const FonPleerYadro = dynamic(
  () => import('@/components/aisearch/fon-pleer-yadro').then((m) => m.FonPleerYadro),
  { ssr: false },
);

/**
 * Место фонового плеера в общем layout локали (`[locale]/layout.tsx`).
 *
 * Общий предок витрины aisearch и кабинета: при переходе между ними по
 * ссылкам этот компонент не перемонтируется, и `<audio>` внутри
 * остаётся тем же элементом — звук не прерывается. Пока плеер не
 * включила ветка aisearch (`vklyuchitFonPleer`), здесь пусто.
 */
export function FonPleerKoren() {
  const vklyuchen = useFonPleerVklyuchen();
  return vklyuchen ? <FonPleerYadro /> : null;
}
